<template>
    <Panel class="card rounded rounded-10">
        <template #header class="card-header">
            <h5>
                <i :class="$t('whitelist.icon') + ' mr-2'"></i>
                Network Access Countries
            </h5>
        </template>

        <div class="card-body">
            <ul class="nav nav-tabs mb-4" role="tablist">
                <li class="nav-item">
                    <a
                        :class="['theme-links', 'nav-link',{ active: activeTab === 0 }]"
                        @click="activeTab = 0"
                        role="tab"
                    >
                        Map
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        :class="['theme-links', 'nav-link',{ active: activeTab === 1 }]"
                        @click="activeTab = 1"
                        role="tab"
                    >
                        Entries
                    </a>
                </li>
            </ul>

            <div class="tab-content">
                <div
                    class="tab-pane fade"
                    :class="{ active: activeTab === 0, 'fade show': activeTab === 0 }"
                    id="whitelist-map-tab"
                    role="tabpanel"
                >

                    <WhitelistMap
                        :whitelist-id="whitelistId"
                        :repaintKey="mapRepaintKey"
                        @region-clicked="showEntriesForRegion"
                        @fetch-error="$emit('fetch-error', $event)"
                    />

                    <div v-if="selectedEntry.length > 0" class="mt-2 mb-2">
                        <Panel class="card rounded rounded-10 mt-2">
                            <template #header class="card-header">
                                <h5>
                                    <i class="fas fa-globe"></i>
                                    Network Access Entries for {{ selectedEntry[0].countryName }}
                                </h5>
                            </template>
                            <DataTable :value="selectedEntry" dataKey="plmn" stripedRows>
                                <Column field="networkOperator" header="Network Operator" />
                                <Column field="imsiId" header="IMSI ID" />
                                <Column field="plmn" header="PLMN" />
                            </DataTable>
                        </Panel>
                    </div>
                </div>

                <div
                    class="tab-pane"
                    :class="{ active: activeTab === 1, 'fade show': activeTab === 1 }"
                    id="whitelist-entries-tab"
                    role="tabpanel"
                >
                    <ClientSideDatatable
                        :key="entriesKey"
                        :title="'Entries'"
                        :header-icon="$t('whitelist.icon')"
                        :object-name="'entries'"
                        :endpoint="`/network-access/${whitelistId}/entries/datatable`"
                        :object-id="'plmn'"
                        @fetch-error="$emit('fetch-error', $event)"
                    >
                    </ClientSideDatatable>
                </div>
            </div>
        </div>
    </Panel>
</template>

<script>
import axios from "axios";
import Panel from "primevue/panel";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import WhitelistMap from "./WhitelistMap.vue";
import WhitelistEntries from "./WhitelistEntries.vue";
import ClientSideDatatable from "../../Datatables/ClientSideDatatable.vue";

export default {
    name: "WhitelistCountries",
    components: {
        ClientSideDatatable,
        Panel,
        DataTable,
        Column,
        WhitelistMap,
        WhitelistEntries,
    },
    props: {
        whitelistId: {
            type: String,
            required: true,
        },
    },
    emits: ["fetch-error"],
    data() {
        return {
            loading: false,
            whitelistEntries: [],
            selectedEntry: [],
            activeTab: 0,
            mapVersion: 0,
            entryVersion: 0,
        };
    },
    computed: {
        mapRepaintKey() {
            return `${this.whitelistId}-${this.mapVersion}`;
        },
        entriesKey() {
            return `${this.whitelistId}-${this.entryVersion}`;
        },
    },
    watch: {

        activeTab(newVal) {
            if (newVal === 0) {
                this.mapVersion += 1;
            }
        },
    },
    methods: {
        fetchWhitelistEntries() {
            this.loading = true;
            axios
                .get(`/network-access/${this.whitelistId}/entries`, {
                    headers: { Accept: "application/json" },
                })
                .then(({ data }) => {
                    this.whitelistEntries = data.data;
                })
                .catch((err) => {
                    this.$emit("fetch-error", {
                        severity: "error",
                        summary: "Error",
                        detail: "Failed to load whitelist entries",
                        life: 3000,
                    });
                    this.whitelistEntries = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showEntriesForRegion(region) {
            this.selectedEntry = this.whitelistEntries.filter(
                (entry) => entry.iso === region
            );
        },
    },
    mounted() {
        this.fetchWhitelistEntries();
    },
};
</script>

<style scoped>
</style>
